var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"rounded-pill",attrs:{"dense":"","items":_vm.items,"label":_vm.label,"clearable":"","outlined":"","error-messages":_vm.errorMessages,"disabled":_vm.disabled},on:{"input":_vm.clearError},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }